"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7188],{

/***/ 26426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _mosanic_fields__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6928);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57389);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51085);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99057);
/* harmony import */ var _util_Text__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68311);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63955);
/* harmony import */ var _mosanic_components_Mail__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16956);
/* harmony import */ var _getTicketData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48919);














var NewTicket = function(param) {
    var data = param.data, _plan = param.plan, plan = _plan === void 0 ? null : _plan, _userData = param.userData, userData = _userData === void 0 ? null : _userData, cta = param.cta, _small = param.small, small = _small === void 0 ? false : _small;
    var ref;
    if (!data) data = (0,_getTicketData__WEBPACK_IMPORTED_MODULE_3__/* .getTicketData */ .O)("default");
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .cI)({
        mode: "all"
    }), handleSubmit = ref1.handleSubmit, control = ref1.control, watch = ref1.watch, _formState = ref1.formState, errors = _formState.errors, isValid = _formState.isValid;
    var inputProps = {
        control: control,
        errors: errors
    };
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), mailSend = ref2[0], setMailSend = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_mosanic_components_Mail__WEBPACK_IMPORTED_MODULE_6__/* .useSendOne */ .x)(), 3), sendMail = ref3[0], sendData = ref3[1], sendLoading = ref3[2];
    // const [sendMail, [sendData, loading, error]] = useLazyQuery('mailSendOne', SEND_MAIL)
    var proPlan = [
        "enterprise",
        "pro"
    ].includes(plan);
    var ticketType = watch().type;
    var mainCategories = "pre-sale|membership|addons|account|support|bug|other";
    var subTypeOptions = function() {
        switch(ticketType){
            case "pre-sale":
                return "enterprise|combined plan|feature info|other";
            case "membership":
                return "upgrade|downgrade|plans|other";
            case "addons":
                return "localization|user roles|connections|other";
            case "account":
                return "login|signup|termination|users|other";
            case "support":
                return "documentation|user guide|topic|priority bug";
            case "bug":
                return "in builder|in inspector|in cms|in admin|other place";
            case "other":
                return "feature request|not included";
            default:
                return "Select a main category first.";
        }
    };
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var subject, from, to;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        subject = "[Ticket received]: ".concat(data === null || data === void 0 ? void 0 : data.type, " ").concat(data === null || data === void 0 ? void 0 : data.subType, "  (").concat(data === null || data === void 0 ? void 0 : data.priority, ")");
                        from = (userData === null || userData === void 0 ? void 0 : userData.firstName) ? "".concat(userData === null || userData === void 0 ? void 0 : userData.firstName, " ").concat(userData === null || userData === void 0 ? void 0 : userData.lastName) : data === null || data === void 0 ? void 0 : data.fullName;
                        to = (userData === null || userData === void 0 ? void 0 : userData.email) ? userData.email : data === null || data === void 0 ? void 0 : data.email;
                        sendMail({
                            subject: "Hi ".concat(from, ", Mosanic has received your ticket."),
                            to: to,
                            preHeader: "\uD83D\uDC40 Keep an eye on your mail, we will get back to you! .",
                            subHeader: "✔️ Ticket submitted.",
                            mainHeader: "We've received your ticket successfully.",
                            mainText: "The content we received is as follows: \n\n      Category: ".concat(data === null || data === void 0 ? void 0 : data.type, " ").concat(data === null || data === void 0 ? void 0 : data.subType, " \n\n      Subject: ").concat(data === null || data === void 0 ? void 0 : data.subject, " \n \n      Text: ").concat(data === null || data === void 0 ? void 0 : data.message, " \n\n      We will get back to your shortly! \n\n      Kind regards,\n\n      -The Mosanic Team")
                        });
                        sendMail({
                            subject: subject,
                            to: "support@mosanic.io",
                            preHeader: "New ticket from: ".concat(from),
                            subHeader: "Priority: ".concat(data === null || data === void 0 ? void 0 : data.priority),
                            mainHeader: data.subject,
                            mainText: "Msg: ".concat(data === null || data === void 0 ? void 0 : data.message, "  \n\n      Category: ").concat(data === null || data === void 0 ? void 0 : data.type, " ").concat(data === null || data === void 0 ? void 0 : data.subType, " \n\n      From: ").concat(from, " \n\n      Email: ").concat(to, " "),
                            simple: true
                        });
                        setMailSend(true);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_8__/* .Card */ .Zb, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                children: data === null || data === void 0 ? void 0 : data.ticketHeader
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_9__/* .AdvancedLabel */ .qv, {
                span: true,
                label: data === null || data === void 0 ? void 0 : data.ticketIntro,
                helpText: data === null || data === void 0 ? void 0 : data.ticketHelp
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("form", {
                disabled: mailSend,
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_10__/* .InputGroup */ .BZ, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                            name: "subject",
                            label: data === null || data === void 0 ? void 0 : data.subject,
                            type: "text",
                            fullWidth: true
                        }, inputProps), {
                            required: true,
                            rules: {
                                required: "".concat(data === null || data === void 0 ? void 0 : data.subject, " is required.")
                            }
                        })),
                        proPlan && (data === null || data === void 0 ? void 0 : data.type) != "termination" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                            name: "priority",
                            type: "select",
                            label: "Ticket priority \uD83D\uDEA8",
                            fullWidth: true
                        }, inputProps), {
                            required: true,
                            options: "critical|high|normal|low|instant chat".split("|"),
                            rules: {
                                required: "Define the priority please."
                            }
                        })),
                        (data === null || data === void 0 ? void 0 : data.type) != "termination" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                    name: "type",
                                    type: "select",
                                    label: small ? "Category" : "Ticket category"
                                }, inputProps), {
                                    required: true,
                                    rules: {
                                        required: "".concat(data === null || data === void 0 ? void 0 : data.subject, " category is required.")
                                    },
                                    options: mainCategories.split("|"),
                                    clearable: false
                                })),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                    name: "subType",
                                    type: "select",
                                    label: small ? "Sub" : "".concat(ticketType ? (0,_util_Text__WEBPACK_IMPORTED_MODULE_14__/* .capitalizeFirst */ .Ez)(ticketType) : "", " sub category")
                                }, inputProps), {
                                    required: true,
                                    rules: {
                                        required: "".concat(ticketType, " sub category is required.")
                                    },
                                    options: (ref = subTypeOptions()) === null || ref === void 0 ? void 0 : ref.split("|"),
                                    clearable: false
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                            name: "message",
                            label: "Message",
                            type: "textarea",
                            fullWidth: true
                        }, inputProps)),
                        !plan && !(userData === null || userData === void 0 ? void 0 : userData.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_10__/* .InputGroupItem */ .oV, {
                                    fullWidth: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                                        children: "Contact details"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                    name: "fullName",
                                    fullWidth: true,
                                    type: "text",
                                    label: "Full name"
                                }, inputProps), {
                                    required: true,
                                    rules: {
                                        required: "Please provide your name."
                                    }
                                })),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields_Input__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                                    name: "email",
                                    fullWidth: true,
                                    type: "email",
                                    label: "E-mail"
                                }, inputProps), {
                                    required: true,
                                    rules: {
                                        required: "Email field is required since we otherwise wouldn't be able to contact you."
                                    }
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_fields__WEBPACK_IMPORTED_MODULE_15__.Button, {
                            type: "submit",
                            wrap: true,
                            disabled: !isValid || mailSend,
                            label: sendLoading ? "Loading" : mailSend ? "Ticket send" : "Submit"
                        })
                    ]
                })
            }),
            mailSend ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_9__/* .AdvancedLabel */ .qv, {
                children: [
                    "Thanks! ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "We've received your ticket and will git back to you shortly. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "Keep an eye on your email for our reply."
                ]
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewTicket);


/***/ }),

/***/ 48919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getTicketData; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _util_Obj__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var presetTickets = {
    "terminate-account": {
        title: "We're sad you left \uD83D\uDE22",
        slug: "The reason we started Mosanic was because of user like you.",
        intro: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                "We value your opinion very much and would massively appreciate it if you would like to tell us why. ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "So we can keep improving and maybe get you back in the future."
            ]
        }),
        help: "Note that it will take up-to 31 days to fully remove all of your data. In this time you will also be able to contact us to check if a revert is possible.",
        ticketHeader: "Leave a message.",
        subject: "Reason",
        type: "termination"
    },
    "default": {
        title: "Ticket \uD83C\uDF9F️",
        intro: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                "Hi There, tell us what going on! ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "We're here to help."
            ]
        }),
        ticketHeader: "Submit a ticket.",
        ticketIntro: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                "Once submitted one of our team members will pick up on the ticket. ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        }),
        subject: "Subject",
        type: "unknown"
    },
    "dashboard": {
        ticketHeader: "Send a ticket \uD83C\uDF9F️",
        ticketIntro: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                "Once submitted one of our team members will pick up on the ticket. ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                "We value your opinion and are here to help!"
            ]
        }),
        subject: "Subject",
        type: "unknown"
    }
};
var getTicketData = function(type) {
    if (!(0,_util_Obj__WEBPACK_IMPORTED_MODULE_2__/* .hasAttr */ .B$)(presetTickets, type)) type = "default";
    return presetTickets[type];
};


/***/ }),

/***/ 37188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Fab; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/components/Ticket/NewTicket.js
var NewTicket = __webpack_require__(26426);
// EXTERNAL MODULE: ./src/mosanic/components/Ticket/getTicketData.js
var getTicketData = __webpack_require__(48919);
// EXTERNAL MODULE: ./src/mosanic/fields/TextArea/index.js + 6 modules
var TextArea = __webpack_require__(71645);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/mosanic/items/Util/StatusDot.js
var StatusDot = __webpack_require__(33402);
;// CONCATENATED MODULE: ./src/mosanic/items/Fab/FloatingActions.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    pointer-events: all;\n    position: fixed;\n    z-index: 5;\n    bottom:10px;\n    right:10px;\n    height: 200px;\n    width: 50px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    border-radius: 30px;\n    background-color: ",
        ";\n    border: none;\n    box-shadow: 0 1px 10px 0 rgba(0,0,0,.2);\n    font-size: 24px;\n    padding: 0;\n    color: white;\n    overflow: hidden;\n\n    color: #000;\n    svg path {\n        fill: #000;\n    }\n    svg {\n        transform: scale(0.6);\n        transform-origin: center center;\n    }\n        \n    transition: .2s ease-out;\n    &:hover {\n        background-color: ",
        ";\n        box-shadow: 0 1px 15px 0 rgba(0,0,0,.4);\n        transform: scale(1.05);\n    }\n    &:focus{\n        outline: none;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        outline: none;\n        background-color: ",
        ";\n        box-shadow: 0 3px 8px rgba(0,0,0,.5);\n\n        & + ul {\n            bottom: 55px;\n            li {\n                margin-bottom: 10px;\n                opacity: 1;\n\n                &:hover label {\n                    opacity: 1;\n                }\n            }\n        }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position: absolute;\n    width: 50px;\n    height: 50px;\n    border-radius: 30px;\n    background-color: #5b19b7;\n    right: 0;\n    bottom: 0;\n    z-index: 20;\n    color: #fff;\n    background-color: ",
        ";\n    svg path {\n        fill: #fff;\n    }\n\n   ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    position:absolute;\n    bottom: 0;\n    right: 0;\n    padding:0;\n    padding-right:5px;\n    margin:0;\n    list-style:none;\n    z-index:10;\n    \n    transition: .2s ease-out;\n    li{\n        z-index: 2;\n        display: flex;\n        justify-content: flex-start;\n        position: relative;\n        margin-bottom: -10%;\n        opacity: 0;\n        \n        transition: .3s ease-out;\n\n        label{\n            position: absolute;\n            right: 45px;\n            white-space: nowrap;\n            display: block;\n            margin-top: 7px;\n            padding: 2px 8px;\n            background-color: white;\n            box-shadow: 0 1px 3px rgba(0,0,0,.2);\n            border-radius:3px;\n            height: 24px;\n            font-size: 12px;\n            /* pointer-events: none; */\n            opacity:0;\n            \n            -webkit-transition: .2s ease-out;\n            -moz-transition: .2s ease-out;\n            transition: .2s ease-out;\n        }\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    background: ",
        ";\n	border-radius: 5px 5px 0 0;\n	color: #fff;\n	cursor: pointer;\n	padding: 10px 24px 8px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    display: inline-block;\n    margin-left: 10px;\n    /* &:before {\n        background: ",
        ';\n        border-radius: 50%;\n        content: "";\n        height: 8px;\n        margin: 0 8px 0 0;\n        width: 8px;\n    } */\n'
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n	background: #fff;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    height: 125px;\n	padding: 8px 14px;\n	overflow-y: scroll;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    &::after {\n        content: '';\n        display: block;\n        clear: both;\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    margin: 10px 0;\n    ",
        " {\n        img{\n            border-radius: 50%;\n            transform: scale(0.9);\n            transform-origin: left center;\n        }\n	    float: left;\n    }\n    ",
        " {\n        float: left;\n        margin-left: 5px;\n        font-size: 10px;\n    }\n    ",
        " {\n        padding-top: 22px;\n        width: 100%;\n        max-width: 150px;\n        margin-left: 36px;\n    }\n    ",
        " {\n        float: right;\n	    font-size: 10px;\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    color: ",
        ";\n    font-size: 9px;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    text-align: right;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    border: 1px solid #ccc;\n	border-radius: 3px;\n	padding: 8px;\n	outline: none;\n	width: 100%;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n        box-shadow: 0 3px 25px rgba(0,0,0,.4);\n        max-height: none;\n        overflow-y: visible;\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n    bottom: 75px;\n	font-size: 12px;\n	right: 15px;\n	position: fixed;\n	width: 220px;\n    max-height: 0;\n    overflow-y: hidden;\n    z-index: 3;\n    transition: all ease-in-out 0.3s;\n    ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}












var Floating = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-0"
})(_templateObject());
var Action = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-94a82f25-1"
})(_templateObject1(), (0,polished_esm/* lighten */.$n)(0.3, colors/* default.util.gray.base */.ZP.util.gray.base), (0,polished_esm/* lighten */.$n)(0.2, colors/* default.util.gray.base */.ZP.util.gray.base));
var Trigger = (0,styled_components_browser_esm/* default */.ZP)(Action).withConfig({
    componentId: "sc-94a82f25-2"
})(_templateObject3(), colors/* default.util.primary.base */.ZP.util.primary.base, function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), colors/* default.util.primary.dark */.ZP.util.primary.dark);
});
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-94a82f25-3"
})(_templateObject4());
var ChatDialog = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-4"
})(_templateObject5());
var ChatHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-5"
})(_templateObject6(), colors/* default.util.primary.darkest */.ZP.util.primary.darkest);
var ChatName = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-94a82f25-6"
})(_templateObject7(), colors/* default.util.bright.green */.ZP.util.bright.green);
var Chat = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-7"
})(_templateObject8());
var ChatHistory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-8"
})(_templateObject9());
var Avatar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-9"
})(_templateObject10());
var Name = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-94a82f25-10"
})(_templateObject11());
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-11"
})(_templateObject12());
var Time = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-12"
})(_templateObject13());
var ChatMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-13"
})(_templateObject14(), Avatar, Name, Content, Time);
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-14"
})(_templateObject15(), colors/* default.util.gray.base */.ZP.util.gray.base);
var ChatInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-94a82f25-15"
})(_templateObject16());
var ChatContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94a82f25-16"
})(_templateObject18(), function(props) {
    return props.active && (0,styled_components_browser_esm/* css */.iv)(_templateObject17());
});
var actions = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "40px",
            height: "40px",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.49,380c1.19-4.38-1.44-10.47-3.95-14.86A44.86,44.86,0,0,0,81,361.34a199.81,199.81,0,0,1-33-110C47.65,139.09,140.73,48,255.83,48,356.21,48,440,117.54,459.58,209.85A199,199,0,0,1,464,251.49c0,112.41-89.49,204.93-204.59,204.93-18.3,0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.09,31.09,0,0,0-11.12-2.07,30.71,30.71,0,0,0-12.09,2.43L81.51,462.78A16,16,0,0,1,76.84,464a9.6,9.6,0,0,1-9.57-9.74,15.85,15.85,0,0,1,.6-3.29Z",
                style: {
                    fill: "none",
                    strokeMiterlimit: 10,
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeWidth: "32px"
                }
            })
        }),
        label: "Live Chat",
        stroke: true
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "40px",
            height: "40px",
            viewBox: "0 0 576 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M424 160H152c-13.255 0-24 10.745-24 24v144c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24zm-8 160H160V192h256v128zm128-96h32V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v112h32c17.673 0 32 14.327 32 32s-14.327 32-32 32H0v112c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V288h-32c-17.673 0-32-14.327-32-32s14.327-32 32-32zm0 96v80c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16v-80c35.29 0 64-28.71 64-64s-28.71-64-64-64v-80c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v80c-35.29 0-64 28.71-64 64s28.71 64 64 64z"
            })
        }),
        label: "Direct Ticket"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            width: "40px",
            height: "40px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
            })
        }),
        label: "Whatsapp"
    }
];
var triggerIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40px",
    height: "40px",
    viewBox: "0 0 512 512",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M431,320.6c-1-3.6,1.2-8.6,3.3-12.2a33.68,33.68,0,0,1,2.1-3.1A162,162,0,0,0,464,215c.3-92.2-77.5-167-173.7-167C206.4,48,136.4,105.1,120,180.9a160.7,160.7,0,0,0-3.7,34.2c0,92.3,74.8,169.1,171,169.1,15.3,0,35.9-4.6,47.2-7.7s22.5-7.2,25.4-8.3a26.44,26.44,0,0,1,9.3-1.7,26,26,0,0,1,10.1,2L436,388.6a13.52,13.52,0,0,0,3.9,1,8,8,0,0,0,8-8,12.85,12.85,0,0,0-.5-2.7Z",
            style: {
                fill: "none",
                strokeMiterlimit: 10,
                stroke: "#fff",
                strokeLinecap: "round",
                strokeWidth: "32px"
            }
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M66.46,232a146.23,146.23,0,0,0,6.39,152.67c2.31,3.49,3.61,6.19,3.21,8s-11.93,61.87-11.93,61.87a8,8,0,0,0,2.71,7.68A8.17,8.17,0,0,0,72,464a7.26,7.26,0,0,0,2.91-.6l56.21-22a15.7,15.7,0,0,1,12,.2c18.94,7.38,39.88,12,60.83,12A159.21,159.21,0,0,0,284,432.11",
            style: {
                fill: "none",
                strokeMiterlimit: 10,
                stroke: "#fff",
                strokeLinecap: "round",
                strokeWidth: "32px"
            }
        })
    ]
});
var FloatingActions = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref;
    var ref1 = (0,react.useState)("trigger"), active = ref1[0], setAction = ref1[1];
    var ref2 = (0,react.useState)(false), focus = ref2[0], setFocus = ref2[1];
    var ref3 = (0,react.useState)("I have a question about .."), inputVal = ref3[0], setInputVal = ref3[1];
    var ref4 = (0,react.useState)(new Date()), time = ref4[0];
    // onBlur={() => setFocus(false)}
    var blur = function() {
        setAction("trigger");
        // setTimeout(() => {
        setFocus(false);
    // }, 100);
    };
    var openWhatsapp = function() {
        return window.open("https://wa.me/31640641745?text=".concat(inputVal), "_ blank");
    };
    var userId = (0,es/* useSelector */.v9)(reducer/* userIdSelector */.dY);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetUser */.pg)({
        _id: userId
    }), 1), user = ref5[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChatContainer, {
                active: active === "Whatsapp" || active === "Live Chat",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChatHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusDot/* default */.Z, {
                                active: active === "Whatsapp",
                                color: "green",
                                size: "large"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatName, {
                                children: "Thijs Zijdel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chat, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatHistory, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChatMessage, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "https://mosanic-cdn.ams3.digitaloceanspaces.com/62e7a50082b1bd8d84a13845/thijszijdel.jpg",
                                                height: "30px",
                                                width: "30px",
                                                alt: "Thijs Zijdel's profile picture"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                            children: "Thijs Zijdel"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Time, {
                                            children: [
                                                time === null || time === void 0 ? void 0 : time.getHours(),
                                                ":",
                                                time.getMinutes() >= 10 ? time.getMinutes() : "0".concat(time.getMinutes())
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                            children: "Hi there, how may i assist to you?"
                                        })
                                    ]
                                })
                            }),
                            active === "Whatsapp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                children: "*Hitting enter opens Whatsapp"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea["default"], {
                                minRows: 1,
                                maxRows: 4,
                                value: inputVal,
                                onChange: function(e) {
                                    return setInputVal(e);
                                },
                                onKeyUp: function(e) {
                                    return (e === null || e === void 0 ? void 0 : e.keyCode) === 13 ? openWhatsapp() : null;
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatContainer, {
                active: active === "Direct Ticket",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewTicket/* default */.Z, {
                    small: true,
                    userData: (0,_object_spread/* default */.Z)({}, user),
                    data: (0,getTicketData/* getTicketData */.O)("help")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Floating, {
                className: "fab",
                onMouseLeave: function() {
                    return active != "trigger" ? null : setFocus(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Trigger, {
                        className: "main",
                        onClick: function() {
                            return !focus ? setFocus(true) : setAction("trigger");
                        },
                        active: focus && active === "trigger",
                        children: active === "trigger" ? triggerIcon : (ref = actions.find(function(a) {
                            return a.label === active;
                        })) === null || ref === void 0 ? void 0 : ref.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                        children: actions === null || actions === void 0 ? void 0 : actions.map(function(a) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: a.label,
                                        children: a.label
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                                        id: a.label,
                                        onClick: function() {
                                            return setAction(a.label);
                                        },
                                        children: a.icon
                                    })
                                ]
                            }, a.label);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/mosanic/items/Fab/index.js

/* harmony default export */ var Fab = (FloatingActions);


/***/ }),

/***/ 33402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var _mosanic_styles_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37971);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78545);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ::before,\n        ::after {\n            content: '';\n            display: block;\n            top: calc(50% - 4px);\n            height: 8px;\n            width: 8px;\n        }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n        ::before {\n            animation: status 1.8s ease-out infinite;\n        }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ::before,\n        ::after {\n            left: -10px; \n        }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        padding: 0 5px;\n        ::before,\n        ::after {\n            left: 0px; \n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n    \n    ::before,\n    ::after {\n        content: '';\n        display: block;\n        top: calc(50% - 2.5px);\n        height: 5px;\n        width: 5px;\n        border-radius: 50%;\n        position: absolute;\n        background: ",
        ";\n    }\n    ",
        "\n    \n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Dot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-463adb04-0"
})(_templateObject4(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.active) ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright */ .ZP.util.bright[props === null || props === void 0 ? void 0 : props.color] : props.forceColor ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright */ .ZP.util.bright[props === null || props === void 0 ? void 0 : props.color] : _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.gray.base */ .ZP.util.gray.base;
}, function(props) {
    return props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
}, function(props) {
    return (props.selected || props.active) && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _mosanic_styles_animations__WEBPACK_IMPORTED_MODULE_5__/* .statusAttention */ .az);
}, function(props) {
    return props.compact ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh);
var StatusDot = function(_param) /*#__PURE__*/ {
    var active = _param.active, _compact = _param.compact, compact = _compact === void 0 ? false : _compact, _color = _param.color, color = _color === void 0 ? "primary" : _color, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "active",
        "compact",
        "color"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dot, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        active: active,
        compact: compact,
        color: color
    }, other));
};
/* harmony default export */ __webpack_exports__["Z"] = (StatusDot);


/***/ })

}]);